<template>
    <inertia-head>
        <title>Rabatter, rabattkoder och erbjudanden till barnfamiljer!</title>
        <meta name="description" content="Familjekortet är ett digitalt rabattkort online som serverar 1000-tals lokala rabatter och rikstäckande rabattkoder och erbjudanden till barnfamiljer - Nyheter varje dag! - Gratis medlemskap!">
        <meta property="og:image" :content="`${$page.props.baseUrl}/assets/frontend/hero.jpg`" />
    </inertia-head>

    <main role="main" class="landing main">
        <div v-for="(block, index) in blocks">
            <div :class="{
                'container-fluid startpage-block-even': index % 2 === 0,
                'ingenious-discount startpage-block-odd': index % 2 !== 0
            }">
                <div class="container-fluid" style="max-width: 1270px;">

                    <!-- Hardcoded slider campaigns block -->
                    <div class="discounts carousel-1-column-stage-padding" v-if="sliderCampaigns.length > 0 && block.type === 'hardcoded:sliders'">
                        <swiper-slider :loop="true" autoplay>
                            <swiper-slide v-for="slider in sliderCampaigns" :key="slider.slug">
                                <inertia-link :href="'/'+slider.company_slug+'/'+slider.slug">
                                    <div class="cimagecontainer" :style="{ 'background-image': 'url(' + slider.hotspot?.image + ')' }"> </div>
                                </inertia-link>
                            </swiper-slide>
                        </swiper-slider>
                    </div>

                    <!-- Hardcoded local heroes campaigns block -->
                    <div v-else-if="block.type === 'hardcoded:local-heroes'">
                        <local-campaigns-list :title="block.title"></local-campaigns-list>
                    </div>

                    <div v-else-if="block.name === 'Nya deals!'">
                        <h2 class="alternative-styling">
                            <inertia-link :href="block.title_link">{{ block.title.replace('|MEMBER_CITY|', currentUser?.city?.name) }}</inertia-link>
                        </h2>

                        <div class="list-result-container mt-3">
                            <div class="list-result px-1 py-1">
                                <div class="row row-cols-2 row-cols-md-5 gx-3 mt-2">
                                    <div class="col mb-4" v-for="(campaign, index) in block.campaigns" :key="campaign.id">
                                        <campaign-item :campaign="campaign" :banner="campaign.banner" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="text-align: center;" v-else>
                        <h2 class="alternative-styling">
                            <inertia-link :href="block.title_link">{{ block.title.replace('|MEMBER_CITY|', currentUser?.city?.name) }}</inertia-link>
                        </h2>

                        <div id="ingenious-carousel" class="carousel-4-item" v-if="block.campaigns?.length > 0" style="position: relative;">
                           <swiper-slider :breakpoints="{
                                0: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 10 },
                                768: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 20 },
                                1024: { slidesPerView: 5, slidesPerGroup: 5, spaceBetween:20 },
                            }">
                                <swiper-slide v-for="campaign in block.campaigns" :key="campaign.slug">
                                    <campaign-item :campaign="campaign" />
                                </swiper-slide>
                            </swiper-slider>
                        </div>
                    </div>


                </div>
            </div>
        </div>

        <!-- <div class="ingenious-discount" style="padding-bottom: 30px;">
            <div class="container-fluid" style="max-width:1270px;">
                <h2 class="alternative-styling">
                    <inertia-link href="/online">Nya rabattkoder online!</inertia-link>
                </h2>

                <div id="ingenious-carousel" class="carousel-4-item" v-if="webshopCampaigns.length > 0">
                   <swiper-slider :breakpoints="{
                        0: { slidesPerView: 2, spaceBetween: 10 },
                        768: { slidesPerView: 4, spaceBetween: 20 },
                        1024: { slidesPerView: 5, spaceBetween:20 },
                    }">
                        <swiper-slide v-for="campaign in webshopCampaigns" :key="campaign.slug">
                            <campaign-item :campaign="campaign" />
                        </swiper-slide>
                    </swiper-slider>
                </div>
            </div>
        </div> -->

        <!-- <div class="new-discounts" style="background-color: #E4F4FB; padding-bottom: 30px;">
            <div class="container-fluid" style="max-width:1270px;">
                <h2 class="alternative-styling">
                    <inertia-link href="/topplista">Våra favoriter!</inertia-link>
                </h2>

                <div id="new-campaigns-scroll" class="carousel-4-item" v-if="favouriteCampaigns.length > 0">
                    <swiper-slider :breakpoints="{
                        0: { slidesPerView: 2, spaceBetween: 10 },
                        768: { slidesPerView: 4, spaceBetween: 20 },
                        1024: { slidesPerView: 5, spaceBetween:20 },
                    }">
                        <swiper-slide v-for="campaign in favouriteCampaigns" :key="campaign.slug">
                            <campaign-item :campaign="campaign" />
                        </swiper-slide>
                    </swiper-slider>
                </div>
            </div>
        </div> -->

        <!-- <local-campaigns-list></local-campaigns-list>

        <div style="background: #fff;">
            <div class="container categories" id="categories">
                <div id="categories-container">
                    <div class="item"  id="category-item" v-for="category in $page.props.categories.filter(c => c.parent_id === null)" :key="category.id">
                        <inertia-link :href="`/${category.slug}`">
                            <icon :name="category.slug"></icon>
                            <span class="icons-start" v-if="category.slug !== 'klader-accessoarer'">{{ category.name.replace(/ .*/, '').replace(',', '') }} </span>
                            <span class="icons-start" v-if="category.slug === 'klader-accessoarer'">Mode</span>
                        </inertia-link>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="our-partners">
            <div class="container">
                <h2 class="alternative-styling" style="padding: 22px 0px 15px;">
                    <inertia-link :href="`/vara-partners`">{{ $t('our_partners') }}</inertia-link>
                </h2>
                <div class="row">
                <div class="col-6 col-md-2 px-2 my-2" v-for="(partner, index) in partners" :key="partner.slug">
                    <div class="text-center company-item bg-white p-3">
                        <inertia-link :href="`/${partner.slug}`">
                            <div v-if="partner.logo" class="cimagecontainer4-3-logo"  v-lazy:background-image="partner.logo"> </div>
                            <img class="logo" v-else  />
                        </inertia-link>
                    </div>
                </div>
                </div>

                <inertia-link href="/vara-partners" class="btn btn-lg btn-danger px-5">{{ $t('all_partners') }}</inertia-link>
            </div>
        </div>

        <div class="splashes">
            <div class="splash splash-landing super">
                <img alt="Super splash" src="/assets/frontend/splash_super.svg">
                <h3 class="splash-text super">{{ $t('super_splash_text') }}</h3>
            </div>
            <div class="splash splash-landing pang">
                <img alt="Pang splash" src="/assets/frontend/splash_pang.svg">
                <h3 class="splash-text pang">{{ $t('pang_splash_text') }}</h3>
            </div>
            <div class="splash splash-landing dunder">
                <img alt="Dunder splash" src="/assets/frontend/splash_dunder.svg">
                <h3 class="splash-text dunder">{{ $t('dunder_splash_text') }}</h3>
            </div>
        </div>

        <!-- <div class="city-dropdown-holder">
            <div class="city-dropdown">
                <select v-model="selectedCity" @change="cityChanged">
                    <option>Hela landet</option>
                    <option v-for="city in cities" :value="city">{{ city.name }}</option>
                </select>
            </div>
        </div> -->
    </main>
</template>

<script>
    import LocalCampaignsList from '@/components/campaign-lists/LocalCampaigns';
    import { SwiperSlide } from 'swiper/vue';
    import SwiperSlider from '@/components/Swiper';
    import CityFilter from '@/mixins/CityFilter';

    export default {
        mixins: [CityFilter],

        props: ['partners', 'sliderCampaigns', 'blocks'],

        components: {
            SwiperSlider, SwiperSlide, LocalCampaignsList
        },

        mounted() {
            let searchParams = new URLSearchParams(window.location.search);
            if( searchParams.has('clientLogin') && !this.currentUser ){
                $("#clientLoginModal").modal("show");
            }
            if( searchParams.has('register') && !this.currentUser ){
                $("#registerModal").modal("show");
            }
            if( searchParams.has('forgotPassword') && !this.currentUser ){
                $("#forgotPasswordModal").modal("show");
            }
            if( searchParams.has('login') && !this.currentUser ){
                $("#loginModal").modal("show");
            }
        },
        methods: {
            cityChanged() {
                this.updateCity();
            },
        },
        computed: {
            currentUser() {
                return this.$page.props.currentUser;
            }
        }
    }
</script>
